import React, { FC } from "react";
import Box from "../../Unknown/Box";
import useStyles from "./useStyles";
import Switch from "../../Unknown/Switch";
import FormControlLabel from "../../Unknown/FormControlLabel";
import useTranslations from "./useTranslations";
import { GridToolbarQuickFilter } from "../../Unknown/DataGrid";

export interface ShowApprovedSwitchProps {
  checked: boolean;
  onChange: (
    event: React.ChangeEvent<HTMLInputElement>,
    checked: boolean,
  ) => void;
}

export interface AppointmentAIReportsTableTopBarProps {
  showApprovedProps: ShowApprovedSwitchProps;
}

const AppointmentAIReportsTableTopBar: FC<
  AppointmentAIReportsTableTopBarProps
> = ({ showApprovedProps }) => {
  const { toolbarRoot } = useStyles();
  const { showApprovedLabel, findNameLabel } = useTranslations();

  return (
    <Box
      className={toolbarRoot}
      p={2}
      pl={3}
      display="flex"
      justifyContent="space-between"
    >
      <Box display="flex" justifyContent="flex-start">
        <FormControlLabel
          control={<Switch size="small" {...showApprovedProps} />}
          label={showApprovedLabel}
        />
      </Box>
      <Box display="flex" justifyContent="flex-end">
        <GridToolbarQuickFilter placeholder={findNameLabel} />
      </Box>
    </Box>
  );
};

export default AppointmentAIReportsTableTopBar;
